import {
  SimpleForm,
  type SimpleFormProps,
} from '../../components/admin/simple-form';
import { cn } from '../../lib/utils';

/** Kit `SimpleForm` that validates on change and warns about unsaved changes. */
export const MoonstarCreateForm = ({
  className,
  ...props
}: SimpleFormProps) => {
  return (
    <SimpleForm
      mode="onChange"
      warnWhenUnsavedChanges
      {...props}
      className={cn(
        'rounded-xl border bg-card p-4 shadow-sm sm:p-6',
        className
      )}
    />
  );
};
